import { useState } from "react";
import AuthGate from "./AuthGate";
import Dashboard from "./Dashboard";
import WhatsAppBotDesigner from "./BotDesigner";
import WhatsAppEmulator from "./WhatsAppEmulator";

const PROVIDER_LABEL = { aad: "Microsoft", github: "GitHub", dev: "Dev" };

function App() {
  const [currentBot, setCurrentBot] = useState(null); // null = dashboard
  const [tab, setTab] = useState("designer");
  const [sharedFlow, setSharedFlow] = useState(null);

  const openBot = (bot) => {
    setCurrentBot(bot);
    setTab("designer");
  };

  const goToDashboard = () => {
    setCurrentBot(null);
    setSharedFlow(null);
  };

  const sendToEmulator = (flow) => {
    setSharedFlow(flow);
    setTab("emulator");
  };

  return (
    <AuthGate>
      {({ user, displayName, avatarLetter, provider, onLogout }) => {
        const userId = `${provider}_${user.userId}`;

        // ── Dashboard ──
        if (!currentBot) {
          return (
            <Dashboard
              userId={userId}
              displayName={displayName}
              avatarLetter={avatarLetter}
              provider={provider}
              onLogout={onLogout}
              onOpenBot={openBot}
            />
          );
        }

        // ── Diseñador + Emulador ──
        return (
          <div style={{ width: "100%", height: "100vh", display: "flex", flexDirection: "column", background: "#0a0e1a" }}>
            {/* Tab bar */}
            <div style={{
              display: "flex", gap: 2, padding: "6px 10px",
              background: "#0f172a", borderBottom: "1px solid #1e293b",
              flexShrink: 0, zIndex: 100, alignItems: "center",
            }}>
              {/* Botón volver al dashboard */}
              <button onClick={goToDashboard} style={{
                padding: "5px 10px", borderRadius: 6, border: "1px solid #334155",
                background: "transparent", color: "#475569", fontSize: 11, cursor: "pointer",
                display: "flex", alignItems: "center", gap: 5, marginRight: 4,
                fontFamily: "'Segoe UI', system-ui, sans-serif",
              }}>
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                  <path d="M6 2L2 5l4 3"/>
                </svg>
                Mis Bots
              </button>

              <div style={{ width: 1, height: 18, background: "#1e293b", marginRight: 4 }} />

              <button onClick={() => setTab("designer")} style={{
                padding: "6px 18px", borderRadius: 6, border: "none", cursor: "pointer",
                fontSize: 12, fontWeight: 600, fontFamily: "'Segoe UI', system-ui, sans-serif",
                background: tab === "designer" ? "#1e40af" : "transparent",
                color: tab === "designer" ? "#fff" : "#64748b",
              }}>
                🎨 Diseñador
              </button>
              <button onClick={() => setTab("emulator")} style={{
                padding: "6px 18px", borderRadius: 6, border: "none", cursor: "pointer",
                fontSize: 12, fontWeight: 600, fontFamily: "'Segoe UI', system-ui, sans-serif",
                background: tab === "emulator" ? "#065f46" : "transparent",
                color: tab === "emulator" ? "#fff" : "#64748b",
              }}>
                📱 Emulador
              </button>

              {/* Nombre del bot activo */}
              <span style={{ fontSize: 11, color: "#334155", marginLeft: 8 }}>
                {currentBot.name}
                {currentBot.phone && <span style={{ color: "#1e293b", marginLeft: 6 }}>{currentBot.phone}</span>}
              </span>

              {/* Usuario (derecha) */}
              <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{
                  width: 26, height: 26, borderRadius: "50%",
                  background: provider === "github" ? "#161b22" : "#1e40af",
                  border: "1px solid #334155",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 11, fontWeight: 700, color: "#e2e8f0", flexShrink: 0,
                }}>{avatarLetter}</div>
                <span style={{ fontSize: 11, color: "#94a3b8", maxWidth: 150, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {displayName}
                </span>
                {provider && PROVIDER_LABEL[provider] && (
                  <span style={{ fontSize: 9, color: "#475569", background: "#1e293b", border: "1px solid #334155", borderRadius: 4, padding: "1px 5px" }}>
                    {PROVIDER_LABEL[provider]}
                  </span>
                )}
                <button onClick={onLogout} style={{
                  padding: "4px 10px", borderRadius: 5, border: "1px solid #334155",
                  background: "transparent", color: "#64748b", fontSize: 11, cursor: "pointer",
                  fontFamily: "'Segoe UI', system-ui, sans-serif",
                }}>Salir</button>
              </div>
            </div>

            {/* Contenido */}
            <div style={{ flex: 1, overflow: "hidden", display: tab === "designer" ? "block" : "none" }}>
              <WhatsAppBotDesigner
                onSendToEmulator={sendToEmulator}
                botId={currentBot.id}
                initialData={currentBot.data}
              />
            </div>
            <div style={{ flex: 1, overflow: "hidden", display: tab === "emulator" ? "block" : "none" }}>
              <WhatsAppEmulator sharedFlow={sharedFlow} botId={currentBot.id} botName={currentBot.name} initialData={currentBot.data} />
            </div>
          </div>
        );
      }}
    </AuthGate>
  );
}

export default App;
